namespace app.autenticacao {
    "use strict";
    
    export class AuthInterceptor {
        
        private loginDialogOpen: boolean = false;

        /** @ngInject **/
        constructor(
            private $q: ng.IQService,
            private $window: ng.IWindowService,
            private $cookies: ng.cookies.ICookiesService,
            private $injector: ng.auto.IInjectorService
        ){
            this.request = this.request.bind(this);
            this.responseError = this.responseError.bind(this);
        }

        public request(config): any {
            let accessToken = this.$cookies.get("access_token");
            let csrfToken = this.$cookies.get("XSRF-TOKEN");

            if (csrfToken) {
                config.headers["X-XSRF-TOKEN"] = csrfToken;
            }
            if (accessToken) {
                config.headers.Authorization = "Bearer " + accessToken;
            }
            config.headers["X-Forwarded-Prefix"] = "gateway";

            return config;
        }

        public responseError(response): any {
            
            let path = this.$window.location.pathname;
            
            if (!this.loginDialogOpen && !!path && !path.startsWith("/publico/")) {
                if (response.status === 401) {
                    let accessToken = this.$cookies.get("access_token");
                                    
                    if (accessToken && response.headers("WWW-Authenticate")) {
                        this.$cookies.remove("access_token");
                        
                        if (path === "/") {
                            this.$window.location.href = "/login";
                        } else {
                            return this.loginDialog(response);
                        }
                    } else if (!accessToken && path !== "/login") {
                        if (path !== "/") {
                            this.$cookies.put("originalUrlRequest", path);
                        }
                        this.$window.location.href = "/login";
                    }
                }
            }
            return this.$q.reject(response);
        }
        
        private loginDialog(response): ng.IPromise<any> {
            return this.$injector.invoke(/** @ngInject*/($http: ng.IHttpService,
            	$mdDialog: ng.material.IDialogService, authService: AuthService) => {
                let promise = null;
                this.loginDialogOpen = true;
                
                if (authService.isLocalAuthentication()) {
					promise = $mdDialog.show({
						controller: LoginControllerDialog,
	                    controllerAs: "vm",
	                    templateUrl: "app/main/autenticacao/login/login-dialog.html",
	                    parent: angular.element(document.body),
	                    clickOutsideToClose: true,
	                    escapeToClose: true,
	                    hasBackdrop: true,
	                    locals : {
	                    	login: authService.getUserLogin()
	                    }
	                }); 
				} else {
					promise = authService.authenticate();
				}
                return promise
                	.then(() => $http(response.config),
                		  () => {
							 this.$window.location.href = "/login";
							 return this.$q.reject(response);
						  })
                	.finally(() => this.loginDialogOpen = false);
           });
        }
    }

    angular
        .module("app.autenticacao").service("AuthInterceptor", AuthInterceptor);
}